<script setup lang="ts">
import { Card, CardContent, CardHeader } from '../card'
import CardTitle from '../card/CardTitle.vue'

defineProps<{
  title?: string
  data: {
    name: string
    color: string
    value: any
  }[]
}>()
</script>

<template>
  <Card class="text-sm">
    <CardHeader v-if="title" class="p-3 border-b">
      <CardTitle>
        {{ title }}
      </CardTitle>
    </CardHeader>
    <CardContent class="p-3 min-w-[180px] flex flex-col gap-2">
      <template v-for="(item, key) in data" :key="key">
        <div v-if="item.color" class="flex justify-between items-center">
          <div class="flex items-center">
            <span class="w-1 h-7 mr-4 rounded-full" :style="{ background: item.color }" />
            <span>{{ item.name }}</span>
          </div>
          <span class="font-semibold ml-4">{{
            typeof item.value === 'number'
              ? `${new Intl.NumberFormat('no').format(item.value).toString()}`
              : item.value
          }}</span>
        </div>
      </template>
    </CardContent>
  </Card>
</template>
